import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, take } from 'rxjs';
import * as Excel from 'exceljs';
import { ExcelSheets } from '../../interfaces/excel-sheets.interface';

@Injectable({
  providedIn: 'root',
})
export class ExcelFileParserService {
  retrievedSheets: ExcelSheets = {};
  namedRanges: Excel.DefinedNamesModel = [];

  loadFileComplete$: Subject<void> = new Subject<void>();

  constructor(private _http: HttpClient) {}

  loadFile(file?: Blob): void {
    if (file) {
      this._loadFileFromBlob(file);
    } else {
      // const filename = 'assets/isep.xlsm';
      // const filename = 'assets/roche.new.xlsm';
      // const filename = 'assets/isep.new.xlsm';
      const filename = 'assets/demo.xlsm';
      // const filename = 'assets/test-file.xlsx';
      this._http
        .get(filename, { responseType: 'blob' })
        .pipe(take(1))
        .subscribe((data) => {
          this._loadFileFromBlob(data);
        });
    }
  }

  loadFromFileObject(file: File): void {
    file.arrayBuffer().then(async (buffer) => {
      const workbook = new Excel.Workbook();
      await workbook.xlsx.load(buffer);
      this._clear();

      workbook.eachSheet((worksheet) => {
        this.retrievedSheets[worksheet.name] = [];
        worksheet.eachRow((row) => {
          this.retrievedSheets[worksheet.name]!.push(row);
        });
      });

      this.namedRanges = workbook.definedNames.model;

      this.loadFileComplete$.next();
    });
  }

  private async _loadFileFromBlob(blob: Blob) {
    const arrayBuffer = await blob.arrayBuffer();
    const workbook = new Excel.Workbook();
    await workbook.xlsx.load(arrayBuffer);
    this._clear();

    workbook.eachSheet((worksheet) => {
      this.retrievedSheets[worksheet.name] = [];
      worksheet.eachRow((row, rowNumber) => {
        this.retrievedSheets[worksheet.name]!.push(row);
      });
    });
    this.namedRanges = workbook.definedNames.model;

    this.loadFileComplete$.next();
  }

  private _clear() {
    this.retrievedSheets = {};
    this.namedRanges = [];
  }
}
